module.exports = __webpack_public_path__ + "static/img/前策-1.78b59cfd.png";